export default defineNuxtRouteMiddleware((to, from) => {

    /**
     * Root
     */
    if (to.path === '/') {
        return navigateTo('/conversations')
    }
})
